function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, openBlock, createBlock, resolveDynamicComponent, mergeProps, unref, withCtx, createElementBlock, Fragment, renderSlot, normalizeClass, createCommentVNode } from 'vue';
import { ElIcon } from '../../icon/index.mjs';
import '../../../hooks/index.mjs';
import { useButton } from './use-button.mjs';
import { buttonProps, buttonEmits } from './button.mjs';
import { useButtonCustomStyle } from './button-custom.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
const __default__ = defineComponent({
  name: "ElButton"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: buttonProps,
  emits: buttonEmits,
  setup(__props, _ref2) {
    let expose = _ref2.expose,
      emit = _ref2.emit;
    const props = __props;
    const buttonStyle = useButtonCustomStyle(props);
    const ns = useNamespace("button");
    const _useButton = useButton(props, emit),
      _ref = _useButton._ref,
      _size = _useButton._size,
      _type = _useButton._type,
      _disabled = _useButton._disabled,
      _props = _useButton._props,
      shouldAddSpace = _useButton.shouldAddSpace,
      handleClick = _useButton.handleClick;
    expose({
      ref: _ref,
      size: _size,
      type: _type,
      disabled: _disabled,
      shouldAddSpace
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), mergeProps({
        ref_key: "_ref",
        ref: _ref
      }, unref(_props), {
        class: [unref(ns).b(), unref(ns).m(unref(_type)), unref(ns).m(unref(_size)), unref(ns).is("disabled", unref(_disabled)), unref(ns).is("loading", _ctx.loading), unref(ns).is("plain", _ctx.plain), unref(ns).is("round", _ctx.round), unref(ns).is("circle", _ctx.circle), unref(ns).is("text", _ctx.text), unref(ns).is("link", _ctx.link), unref(ns).is("has-bg", _ctx.bg)],
        style: unref(buttonStyle),
        onClick: unref(handleClick)
      }), {
        default: withCtx(() => [_ctx.loading ? (openBlock(), createElementBlock(Fragment, {
          key: 0
        }, [_ctx.$slots.loading ? renderSlot(_ctx.$slots, "loading", {
          key: 0
        }) : (openBlock(), createBlock(unref(ElIcon), {
          key: 1,
          class: normalizeClass(unref(ns).is("loading"))
        }, {
          default: withCtx(() => [(openBlock(), createBlock(resolveDynamicComponent(_ctx.loadingIcon)))]),
          _: 1
        }, 8, ["class"]))], 64)) : _ctx.icon || _ctx.$slots.icon ? (openBlock(), createBlock(unref(ElIcon), {
          key: 1
        }, {
          default: withCtx(() => [_ctx.icon ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.icon), {
            key: 0
          })) : renderSlot(_ctx.$slots, "icon", {
            key: 1
          })]),
          _: 3
        })) : createCommentVNode("v-if", true), _ctx.$slots.default ? (openBlock(), createElementBlock("span", {
          key: 2,
          class: normalizeClass({
            [unref(ns).em("text", "expand")]: unref(shouldAddSpace)
          })
        }, [renderSlot(_ctx.$slots, "default")], 2)) : createCommentVNode("v-if", true)]),
        _: 3
      }, 16, ["class", "style", "onClick"]);
    };
  }
}));
var Button = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "button.vue"]]);
export { Button as default };